import { render, staticRenderFns } from "./mes-declarations.vue?vue&type=template&id=1b430a7e&scoped=true"
import script from "./mes-declarations.vue?vue&type=script&lang=ts"
export * from "./mes-declarations.vue?vue&type=script&lang=ts"
import style0 from "./mes-declarations.vue?vue&type=style&index=0&id=1b430a7e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b430a7e",
  null
  
)

export default component.exports